export class OffDayCompensationModel {
  FlexEarningPercentage: number;
  FlexBaseCalculationMethodId: number;
}
